import { Link } from "react-router-dom";
import { getFeaturedArticles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2
              className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              精选文章推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              编辑精选的高质量P站视频使用指南文章
            </p>
          </div>
          <Link
            to="/category/hot-recommend"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.slice(0, 6).map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/hot-recommend"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}